module.exports = __webpack_public_path__ + "static/media/applegreen.c6a329d9.png";